module.exports = __webpack_public_path__ + "media/plantation_farm.b72ef4a8.jpg";